<!--
 * @Descripttion:
 * @version:
 * @Author: shenlin
 * @Date: 2021-11-02 15:49:14
 * @LastEditors: shenlin
 * @LastEditTime: 2022-09-27 17:04:49
-->
<template>
  <div class="app-container">
    <div class="header">
      <div class="header-serach">
        <el-form :inline="true" :model="ruleform">
          <el-form-item label="">
            <el-input
              v-model="ruleform.searchKey"
              placeholder="搜索活动、主办单位"
              @keyup.enter.native="getSearch"
            >
              <i
                @click="getSearch"
                slot="suffix"
                class="el-input__icon el-icon-search"
              ></i
            ></el-input>
          </el-form-item>
          <el-form-item label="状态">
            <el-select
              v-model="ruleform.status"
              placeholder="请选择直播状态"
              @change="getPoss"
              clearable
            >
              <el-option
                v-for="item in statusList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="区域">
            <el-select
              v-model="ruleform.areaCode"
              placeholder="请选择区域"
              @change="getPoss"
              clearable
            >
              <el-option
                v-for="item in areaList"
                :key="item.code"
                :label="item.county"
                :value="item.code"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="开始时间">
            <el-date-picker
              v-model="ruleform.videoTime"
              type="datetimerange"
              @change="getPoss"
              value-format="yyyy-MM-dd HH:mm:ss"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              clearable
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="活动类型">
            <el-select
              v-model="ruleform.activityKind"
              placeholder="请选择区域"
              @change="getPoss"
              clearable
            >
              <el-option
                v-for="item in activityList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否同步省平台">
            <el-select
              v-model="ruleform.syncStatus"
              placeholder="请选择区域"
              @change="getPoss"
              clearable
            >
              <el-option
                v-for="item in syncStatusList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <div class="addPru" @click="add">新增活动</div>
    </div>
    <el-table
      :data="tableData"
      style="width: 100%"
      :header-cell-style="{ background: '#fafafa' }"
      height="500"
    >
      <el-table-column
        prop="activityName"
        label="活动名称"
        width="250"
        align="center"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column label="活动类型" align="center" show-overflow-tooltip>
        <template slot-scope="scope">
          <span>{{ scope.row.activityKind | activeStatus }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="status" label="状态" align="center">
        <template slot-scope="scope">
          <div>
            {{ liveStatus(scope.row.status) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="hostUnit"
        label="主办单位"
        align="center"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="startTime"
        label="开始时间"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="county"
        label="所属区域"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="joinCount"
        label="报名人数"
        sortable
        align="center"
      ></el-table-column>
      <el-table-column
        prop="reachCount"
        label="签到人数"
        sortable
        align="center"
      ></el-table-column>
      <el-table-column align="center">
        <template v-slot:header>
          <span style="margin-right:5px">是否同步省平台</span>
          <el-tooltip
            content="只有上架的活动才能同步到省企业码平台，且一个活动只能同步一次"
            placement="top"
            effect="dark"
          >
            <i class="el-icon-warning-outline"></i>
          </el-tooltip>
        </template>
        <template slot-scope="scope">
          <span>{{ scope.row.syncStatus | syncStatus }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="220" align="center">
        <template slot-scope="scope">
          <span
            :class="[!scope.row.isDeploy ? 'actcolor' : 'nocolor']"
            style="cursor: pointer; margin-right: 10px; margin-left: -10px"
            @click="shelf(scope.row, 1)"
            >上架</span
          >
          <span
            :class="[scope.row.isDeploy ? 'actcolor' : 'nocolor']"
            style="margin-right: 10px; cursor: pointer"
            @click="shelf(scope.row, 0)"
            >下架</span
          >
          <span
            v-if="scope.row.syncStatus == 0 && scope.row.isDeploy == 1"
            class="actcolor"
            style="margin-right: 10px; cursor: pointer"
            @click="syncActivityData(scope.row.id)"
            >同步省平台</span
          >
          <span
            :class="[scope.row.isDeploy === 0 ? 'nocolor' : 'actcolor']"
            style="margin-right: 10px; cursor: pointer"
            @click="share(scope.row)"
            >分享</span
          >
          <el-popover placement="top-start" width="100" trigger="click">
            <div>
              <p
                style="text-align: center; cursor: pointer"
                @click="registration(scope.row.id)"
              >
                活动报表
              </p>
              <p
                style="text-align: center; cursor: pointer"
                @click="edit(scope.row.id)"
              >
                编辑
              </p>
              <p
                style="text-align: center; cursor: pointer"
                @click="deleteEntTrain(scope.row.id)"
              >
                删除
              </p>
            </div>
            <span slot="reference" style="color: #1890ff; cursor: pointer"
              >更多</span
            >
          </el-popover>
        </template>
      </el-table-column>
    </el-table>
    <div class="table-page">
      <el-pagination
        background
        layout="total,prev, pager, next, sizes, jumper"
        :current-page.sync="currentPage"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :page-size="pageSize"
        :total="totalRecord"
      >
      </el-pagination>
    </div>
    <el-dialog
      title="活动报表"
      :visible.sync="centerDialogVisible"
      width="70%"
      center
    >
      <div style="display: flex; justify-content: space-between">
        <div>活动名称：{{ activityName }}</div>
        <div>报名人数：{{ joinCount }}</div>
      </div>
      <el-table
        :data="activeTableData"
        style="width: 100%"
        :header-cell-style="{ background: '#fafafa' }"
        height="300"
      >
        <el-table-column type="index" label="序号" width="50">
        </el-table-column>
        <el-table-column
          prop="entName"
          label="企业名称"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column prop="town" label="所在区域"> </el-table-column>
        <el-table-column prop="staffName" label="参会人"></el-table-column>
        <el-table-column prop="mobile" label="手机号码"></el-table-column>
        <el-table-column prop="county" label="报名时间"></el-table-column>
        <el-table-column prop="isSign" label="是否签到" width="80">
          <template slot-scope="scope">
            <div>
              {{ !scope.row.isSign ? '未签到' : '已签到' }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="reachTime" label="签到时间"></el-table-column>
      </el-table>
      <div class="table-page">
        <el-pagination
          background
          layout="total,prev, pager, next, sizes, jumper"
          :current-page.sync="activeCurrentPage"
          @size-change="activeHandleSizeChange"
          @current-change="activeHandleCurrentChange"
          :page-size="activePageSize"
          :total="activeTotalRecord"
        >
        </el-pagination>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="exportList">下载Excel表格</el-button>
      </span>
    </el-dialog>
    <el-dialog title="分享" :visible.sync="shareCode" width="24%">
      <div class="sharing-code" v-if="false">
        <span>链接：</span>
        <el-input
          v-model="sharingCodeInput"
          type="text"
          placeholder="示例：https://www.baidu.com/"
          style="width: 70%; margin-left: 20px"
          size="medium"
          @change="makeCode"
          disabled
        ></el-input>

        <el-button type="primary" size="medium" @click="copyText($event)"
          >复制</el-button
        >
      </div>
      <div class="exhibition">
        <!-- <span>二维码：</span> -->
        <div class="refreshs">
          <span>请使用丽企之家扫码</span>
          <div id="qrcode"></div>
          <!-- <div @click="makeCode" class="refresh">
            <i class="el-icon-refresh"></i>刷新
          </div> -->
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  syncActivityData,
  getActivityDataByPage,
  getArea,
  getSignRecordByPage,
  deleteActivityData,
  updateActivityData,
  exportRecording
} from '@api/activityCenter/activityCenter'
import { removeLocalStorage, setLocalStorage } from '@utils'
import QRCode from 'qrcodejs2'
import clipboard from '../../../utils/clipboard'
export default {
  data() {
    return {
      ttt: true,
      areaList: [],
      centerDialogVisible: false,
      shareCode: false,
      sharingCode:
        process.env.NODE_ENV === 'development'
          ? 'http://10.1.1.124:8824/ent.html#/login'
          : 'https://qym.jxj.lishui.gov.cn/ent.html#/login',
      // sharingCode: 'http://10.1.2.117:1402/ent.html#/login',
      sharingCodes: '',
      sharingCodeId: '',
      sharingCodeInput: '',
      codeList: '',
      qr: '',
      codeId: '',
      ruleform: {
        searchKey: '', // 视频名称
        areaCode: '', // 活动区域
        status: '', // 视频状态
        videoTime: '', // 视频时间
        activityKind: '', // 活动类型
        syncStatus: '' // 是否同步到省平台
      },
      syncStatusList: [
        { value: '', label: '全部' },
        { value: 0, label: '否' },
        { value: 1, label: '是' }
      ],
      activityList: [
        { value: '', label: '全部' },
        { value: '1', label: '信息服务' },
        { value: '2', label: '投融资服务' },
        { value: '3', label: '创业服务' },
        { value: '4', label: '人才培训' },
        { value: '5', label: '培训服务' },
        { value: '6', label: '技术创新和质量服务' },
        { value: '7', label: '数字化赋能服务' },
        { value: '8', label: '管理咨询' },
        { value: '9', label: '市场开拓' },
        { value: '10', label: '法律服务' }
      ],
      statusList: [
        { value: '', label: '全部' },
        { value: 1, label: '未开始' },
        { value: 2, label: '进行中' },
        { value: 3, label: '已结束' }
      ], // 所有类别数据
      typeList: [
        { value: '', label: '全部' },
        { value: 1, label: '法律专题' },
        { value: 2, label: '企业家培训专题' },
        { value: 3, label: '安全生产专题' },
        { value: 4, label: '党建专题' }
      ], // 所有类别数据
      tableData: [],
      pageSize: 10,
      currentPage: 1,
      totalRecord: 0,
      paginationBoxReflow: true,
      repeat: false,
      activeCurrentPage: 1,
      activePageSize: 10,
      activeTotalRecord: 0,
      activeTableData: [],
      activityName: '',
      joinCount: ''
    }
  },
  watch: {
    condition(val) {
      // console.log(val)x
      this.currentPage = 1
      this.listLiveData()
    }
    // ruleform: {
    //   handler(val) {
    //     console.log(val)
    //   },
    //   deep: true
    // }
  },
  computed: {
    liveStatus() {
      return number => {
        let val
        switch (number) {
          case 1:
            val = '未开始'
            break
          case 2:
            val = '进行中'
            break
          case 3:
            val = '已结束'
            break
        }
        return val
      }
    },
    condition({ ruleform }) {
      return {
        areaCode: ruleform.areaCode,
        status: ruleform.status,
        videoTime: ruleform.videoTime
      }
    }
  },
  created() {
    this.getArea()
  },
  mounted() {
    this.listLiveData()
  },
  filters: {
    syncStatus(value) {
      switch (value) {
        case 0:
          return '否'
        case 1:
          return '是'
      }
    },
    activeStatus(value) {
      switch (value) {
        case '1':
          return '信息服务'
        case '2':
          return '投融资服务'
        case '3':
          return '创业服务'
        case '4':
          return '人才培训'
        case '5':
          return '培训服务'
        case '6':
          return '技术创新和质量服务'
        case '7':
          return '数字化赋能服务'
        case '8':
          return '管理咨询'
        case '9':
          return '市场开拓'
        case '10':
          return '法律服务'
        default:
          return '-'
      }
    }
  },
  methods: {
    syncActivityData(id) {
      this.$confirm('确定将该活动同步到省企业码平台吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        syncActivityData({ id: id }).then(res => {
          if (res.data.code == '0000') {
            this.$message.success(res.data.msg)
            this.listLiveData()
          } else {
            this.$message.error(res.data.msg)
          }
        })
      })
    },
    exportList() {
      let params = { activityId: this.activityId }
      exportRecording(params)
    },
    getScanQrcode() {
      this.$store
        .dispatch('user/getScanQrcode')
        .then(resData => {
          this.$nextTick(() => {
            this.sharingCodes = resData.data.qrcode
            if (this.qr) {
              this.qr.clear() // 清除代码
              this.qr.makeCode(resData.data.qrcode) // 生成另外一个二维码
            } else {
              this.qrcode(resData.data.qrcode)
            }
          })
          this.ticket = resData.data.ticket
          this.checkScanStatus()
        })
        .catch(() => {
          this.loading = false
        })
    },
    checkScanStatus() {
      const self = this
      this.$store
        .dispatch('user/shareScanStatus', { ticket: this.ticket })
        .then(res => {
          if (res.status == '00') {
            clearInterval(this.settime)
            window.open(this.sharingCodeId + '&token=' + res.token)
          }
          if (res.status == '05') {
            this.settime = setTimeout(function() {
              self.checkScanStatus()
            }, 1000)
          }
          if (res.status == '02') {
            this.settime = setTimeout(function() {
              self.checkScanStatus()
            }, 1000)
          }
          if (res.status == '08' || res.status == '06') {
            this.$message({
              message: res.message,
              type: 'warning'
            })
          }
        })
        .catch(() => {
          this.loading = false
        })
    },
    // 分享
    share(e) {
      if (e.isDeploy === 0) {
        this.$message('该活动未上架')
        return
      }
      this.shareCode = true
      const url = window.location.href.split('#')[0]
      this.sharingCodeInput = url + '#/qrCode?id=' + e.id + '&type=1'
      this.sharingCodeId = ''
      this.sharingCodeId = this.sharingCode + '?id=' + e.id + '&type=1'
      this.codeId = e.id
      // this.getScanQrcode()
      setTimeout(() => {
        if (this.qr) {
          this.qr.clear() // 清除代码
          this.qr.makeCode(this.sharingCodeId) // 生成另外一个二维码
        } else {
          this.qrcode(this.sharingCodeId)
        }
      }, 500)
    },
    // 生成二维码
    qrcode(code) {
      this.qr = new QRCode('qrcode', {
        width: 150, // 二维码宽度，单位像素
        height: 150, // 二维码高度，单位像素
        text: code // 生成二维码的链接
      })
    },
    makeCode(code) {
      this.qr.clear() // 清除代码
      this.qr.makeCode(this.sharingCodeId) // 生成另外一个二维码
    },
    // 复制链接
    copyText(event) {
      const url = window.location.href.split('#')[0]
      const code = url + '#/qrCode?id=' + this.codeId + '&type=1'
      clipboard(code, event)
      this.$message({
        message: '复制成功',
        type: 'success'
      })
    },
    /** 上架下架 */
    shelf(val, number) {
      if (val.isDeploy == number) {
        if (number) {
          this.$message('该活动已上架')
          return false
        } else {
          this.$message('该活动已下架')
          return false
        }
      }
      updateActivityData({ id: val.id, isDeploy: number }).then(res => {
        if (res.data.code == '0000') {
          this.$message.success(res.data.msg)
          this.listLiveData()
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    /** 获取丽水市以及各个区县 */
    getArea() {
      getArea({}).then(res => {
        if (res.data.code == '0000') {
          this.areaList = res.data.data || []
        }
      })
    },
    // 视频名称
    getSearch() {
      this.currentPage = 1
      this.listLiveData()
    },
    // 所有类别
    getPoss() {
      this.currentPage = 1
      this.listLiveData()
    },
    activeHandleSizeChange(val) {
      this.activePageSize = val
      this.getActiveList()
    },
    activeHandleCurrentChange(currentPage) {
      this.activeCurrentPage = currentPage
      this.getActiveList()
    },
    //  表格翻页
    handleCurrentChange(currentPage, e) {
      this.currentPage = currentPage
      this.listLiveData()
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.listLiveData()
    },
    // 新增
    add() {
      this.$router.push({ name: 'activityDetail' })
    },
    edit(id) {
      this.$router.push({ name: 'activityDetail', query: { id: id } })
    },
    // 列表
    listLiveData() {
      let par = { ...this.ruleform }
      delete par.videoTime
      par.pageNum = this.currentPage
      par.pageSize = this.pageSize
      par.startTime = this.ruleform.videoTime ? this.ruleform.videoTime[0] : ''
      par.endTime = this.ruleform.videoTime ? this.ruleform.videoTime[1] : ''
      getActivityDataByPage(par).then(res => {
        if (res.data.code == '0000') {
          const list = res.data.data
          this.tableData = list.results || []
          this.totalRecord = list.totalRecord || 0
        }
      })
    },

    // 删除
    deleteEntTrain(id) {
      this.$confirm('是否确定删除活动列表数据?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'error'
      }).then(() => {
        deleteActivityData({ id: id }).then(res => {
          if (res.data.code == '0000') {
            this.$message.success('删除成功')
            this.listLiveData()
          } else {
            this.$message.error(res.data.msg || '删除账号失败')
          }
        })
      })
    },
    /** 活动列表 */
    registration(id) {
      this.activityId = id
      this.centerDialogVisible = true
      this.getActiveList()
    },
    getActiveList() {
      let par = {
        activityId: this.activityId,
        pageNum: this.activeCurrentPage,
        pageSize: this.activePageSize
      }
      getSignRecordByPage(par).then(res => {
        if (res.data.code == '0000') {
          this.activeTableData = res.data.data.results || []
          this.activeTotalRecord = res.data.data.totalRecord || 0
          this.activityName = res.data.data.activityName
          this.joinCount = res.data.data.joinCount
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.header {
  display: flex;
  margin-bottom: 20px;
  .header-serach {
    .el-input {
      width: 300px;
      margin-right: 30px;
    }
  }
  .addPru {
    width: 100px;
    display: inline-block;
    text-align: center;
    position: absolute;
    right: 50px;
    height: 36px;
    border-radius: 5px;
    line-height: 36px;
    background: #1890ff;
    color: #fff;
    cursor: pointer;
  }
}
.actcolor {
  color: #1890ff;
}
.nocolor {
  color: rgba(0, 0, 0, 0.3);
}
.changeAppeal {
  cursor: pointer;
  color: #1890ff;
}
.el-table::before {
  height: 0px;
}
.table-page {
  width: 100%;
  text-align: center;
  margin-top: 24px;
  margin-bottom: 20px;
}
.sharing-code {
  display: flex;
  span {
    line-height: 34px;
  }
  /deep/.el-input__inner {
    border-top-right-radius: 0 !important;
    border-bottom-right-radius: 0 !important;
  }
  /deep/.el-button--medium {
    border-top-left-radius: 0 !important;
    border-bottom-left-radius: 0 !important;
  }
}
.exhibition {
  // margin-top: 20px;
  margin-left: -25px;
  display: flex;
  #qrcode {
    width: 125px;
    height: 150px;
    margin: 20px auto;
  }
  .refreshs {
    margin: 20px auto;
    span {
      margin-left: 22px;
    }
    .refresh {
      margin-left: 50px;
      cursor: pointer;
    }
  }
}
</style>
<style lang="scss">
.el-tooltip__popper {
  max-width: 300px;
}
.el-popover {
  min-width: 100px !important;
}
</style>
